import {
  usePageNumberFromUrl,
  usePerPageValueFromUrl,
  useSortValueFromUrl,
} from 'idsk-react-components';
import { SortDirectionEnum } from 'elegislativa-frontend-ts-axios';
import UlohyOrganizacieListPage
  from '../../../../../model/legislativnyMaterial/UlohyOrganizacieListPage';
import {
  defaultPerPageValue,
  perPageDataArray,
} from '../../../../../constants/PaginationPerPageConstants';
import { useClientFetch } from '../../../../../context/ClientStatusContext';
import {
  fetchUlohyOrganizacie,
} from '../../../../../client/legislativnyMaterial/ulohyOrganizacieClient';
import { ClientStatus } from '../../../../../model/ClientStatus';
import useSearchTextFilterFromUrl from '../../../../../hooks/useSearchTextFilterFromUrl';

interface ReturnType {
  ulohyOrganizacie: UlohyOrganizacieListPage;
  ulohyOrganizacieStatus: ClientStatus;
  searchText: string
}

const getSort = (sortValue): string => {
  switch (sortValue) {
    case 'meno':
      return sortValue;
    case 'pocetUloh':
      return sortValue;
    default:
      return 'meno';
  }
};

const getSortByEnum = (sort): SortDirectionEnum => (sort[1] === 'desc'
  ? SortDirectionEnum.Desc : SortDirectionEnum.Asc);

export default (): ReturnType => {
  const { page } = usePageNumberFromUrl();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();
  const filter = useSearchTextFilterFromUrl();

  const {
    data: ulohyOrganizaciePage,
    status: requestStatus,
  } = useClientFetch(
    fetchUlohyOrganizacie,
    [page, perPageValue, getSort(sort[0]), getSortByEnum(sort), filter ? filter.trim() : filter],
    [page, perPageValue, sort[0], sort[1], filter],
  );
  return {
    ulohyOrganizacie: ulohyOrganizaciePage,
    ulohyOrganizacieStatus: requestStatus,
    searchText: filter,
  };
};
